import React from 'react';
import './VideoPage.css';

const videos = [
    {
      title: 'Welcome To Build Start',
      url: 'https://youtu.be/E828QwUoUIY',
    },
    {
      title: 'The Building Journey',
      url: 'https://youtu.be/1e_u81WHxxI',
    },
  ];
  
  const VideoPage = () => {
    return (
      <div style={{ padding: '40px' }}>
        <h1>The Building Journey - Video Learning Centre</h1>
        <ul style={{ marginTop: '20px', listStyleType: 'none' }}>
          {videos.map((video, index) => (
            <li key={index} style={{ marginBottom: '10px' }}>
              <a href={video.url} target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none' }}>
                {video.title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  
  export default VideoPage;